// pages/+Page.tsx
import { lazy, Suspense } from "react";
import LoadingComponent from "../../components/layout/LoadingComponent";
import OpenRoute from "@fableous/ui/components/routes/OpenRoute";
const Legal = lazy(() => import ('../../containers/compliance/Legal'));

function Page() {
  return (
    <Suspense fallback={<LoadingComponent />}>
        <OpenRoute><Legal /></OpenRoute>
    </Suspense>
  );
}

export {Page};